import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import formatPrice, { roundUpParser } from '@honda-canada/js-utilities/lib/formatPrice';
import { Box, Image, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import PriceComponent from '../PriceComponent';
import TrimDetails from '../TrimOverview/TrimDetails';
import themeStyles from './SummaryCard.styles';
import useSellingPriceConfiguration from '../PriceComponent/useSellingPriceConfiguration';
const SummaryCardHeaderWrapper = themeStyles.apply(Box, 'SummaryCardHeaderWrapper');
const ModelBadge = themeStyles.apply(Image, 'ModelBadge');
const priceComponentStyles = {
    pricesContainer: {
        marginBottom: 0,
    },
    priceStyles: {
        title: {
            size: 'extraSmall',
            styles: {
                textWrap: 'nowrap',
            },
        },
        copy: {
            styles: {
                pt: 'xxs',
                fontSize: ['16px', '16px', '18px'],
                lineHeight: ['20px', '20px', '22px'],
            },
        },
        tooltipContainer: {
            mt: ['-1px', '-1px', '1px'],
            mb: '1px',
            pt: ['zero', 'zero', '2px'],
            tooltip: {
                alignSelf: 'center',
            },
        },
        container: {
            mt: 'zero',
        },
    },
};
const priceFormatter = (price, language) => formatPrice(price, language, 0, roundUpParser);
const SummaryCardHeader = ({ vehicle, nameBadge, paymentData, includeFees, overriddenIsSellingProvince, }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const { sellingPriceTooltipLabelValue } = useSellingPriceConfiguration();
    const sellingPriceTooltipLabel = includeFees
        ? t('Shared.Common.sellingPriceDisclaimerWithTaxLabel')
        : sellingPriceTooltipLabelValue;
    const prices = {
        allInPrice: { ...(_a = paymentData.data) === null || _a === void 0 ? void 0 : _a.sellingPrice, label: t('Shared.Common.sellingPriceLabel') },
        msrpPrice: { ...(_b = paymentData.data) === null || _b === void 0 ? void 0 : _b.sellingPrice, label: t('Shared.Common.sellingPriceLabel') },
    };
    return (_jsxs(SummaryCardHeaderWrapper, { children: [_jsxs(Box, { children: [_jsx(ModelBadge, { src: nameBadge === null || nameBadge === void 0 ? void 0 : nameBadge.src, alt: nameBadge === null || nameBadge === void 0 ? void 0 : nameBadge.alt, "data-testid": "cy-summary-card-namebadge" }), _jsx(Optional, { when: (vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelYear) && (vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName) && ((_c = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _c === void 0 ? void 0 : _c.transmissionName), children: _jsx(TrimDetails, { transmissionName: (_d = vehicle === null || vehicle === void 0 ? void 0 : vehicle.transmission) === null || _d === void 0 ? void 0 : _d.transmissionName, modelYear: vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelYear, trimName: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimName, align: "flex-start", size: "subheading" }) })] }), _jsx(Box, { children: _jsx(PriceComponent, { allInPriceTooltipLabel: sellingPriceTooltipLabel, errorMessage: t('Pages.Bap.apiLoadingError'), hasError: !!paymentData.error, height: ['auto', 'auto', undefined], horizontalAlignment: ['right', 'right', 'right'], isFetching: paymentData.isFetching || paymentData.isUninitialized, msrpStartingFromTooltipLabel: t('Shared.Common.msrpDisclaimerLabel'), priceComponentStyles: priceComponentStyles, prices: prices, alignItems: undefined, saveAboveLabel: undefined, suppressDiscount: undefined, showSellingPriceDisclaimer: undefined, frieghtPDIFeesCost: undefined, priceFormatter: priceFormatter, errorIconName: "exclamationAlert", overrideShowSellingPrice: overriddenIsSellingProvince, isLoadingIconLarge: true, loadingIconHeight: "28px", dealerFee: undefined, showRebateDisclaimerIndicator: false }) })] }));
};
export default SummaryCardHeader;
